export default __webpack_public_path__ + "static/media/ic_help-circle.aeb5e1a4.svg";